<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 mr-auto ml-auto">
        <simple-wizard>
          <template slot="header">
            <h3 class="card-title">{{brandName}}開店流程</h3>
            <!-- <h3 class="description">This information will let us know more about you.</h3> -->
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              <i class="now-ui-icons users_circle-08"></i>
              官方帳號設定
            </template>
            <first-step ref="step1" @on-validated="onStepValidated"></first-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <i class="now-ui-icons ui-1_settings-gear-63"></i>
              商店資訊
            </template>
            <second-step ref="step2" @on-validated="onStepValidated"></second-step>
          </wizard-tab>

          <wizard-tab :before-change="() => wizardComplete('step3')">
            <template slot="label">
              <i class="now-ui-icons ui-1_email-85"></i>
              選擇圖文選單
            </template>
            <third-step ref="step3" @on-validated="onStepValidated"></third-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "./Wizard/FirstStep.vue";
import SecondStep from "./Wizard/SecondStep.vue";
import ThirdStep from "./Wizard/ThirdStep.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";
import { createAccounts, createBusinesses, createRichmenu, createDefaultItem } from "./postData";
import axios from "axios";
import { assignToSpecificSiAccount } from "./updateData";

export default {
  computed: {
    brandName() {
      return process.env.BRANDNAME;
    }
  },
  data() {
    return {
      wizardModel: {},
      finished: false,
      businessId: ""
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete(ref) {
      this.$refs[ref].finish();
      console.log("this.wizardModel: ", this.wizardModel)
      if(this.$refs[ref].selectedRichmenu.fileName == "jessica_catering-reviewPlusFB") {
        if(this.wizardModel.googleReviewUrl && this.wizardModel.FBUrl) {

        } else if(this.wizardModel.isChatbotDisabled) {

        } else {
          swal("錯誤", "行銷選單必須填入FB粉專及google review網址", "error")
          return;
        }
      }
      if(!this.finished) {
        let body = this.wizardModel;
        var accountId = "";
        var siAccountId = body.siAccountId;
        body.type = 'retail';
        if(!siAccountId) {
          swal("錯誤", "請選擇SI", "error")
          throw new Error("請選擇SI");
        }
        createAccounts(body)
          .then(response => {
            accountId = response.data.accountId;
            if (!accountId) {
              throw new Error("LINE帳號設定錯誤")
            } else {
              body.accountId = accountId;
              return createBusinesses(body);
            }
          })
          .then(response => {
            let businessId = response.data.businessId;
            if(!businessId) {
              throw new Error("商店資訊設定錯誤")
            } else {
              this.businessId = businessId;
              body.businessId = businessId;
              let data = {
                fileName: this.$refs[ref].selectedRichmenu.fileName,
                siAccountId,
                type: 'retail'
              };
              if(this.wizardModel.isChatbotDisabled) {
                alert('No chatbot');
                return true;
              } else {
                return createRichmenu(body.accountId, data);
              }
            }
          })
          .then(res => {
            // add menu, cateogry, product (default item)
            return createDefaultItem(accountId);
          })
          .then(res => {
            let updateData = {
              shopId: 1, // hardcode, 沒作用
              accountId: accountId,
              siAccountId: body.siAccountId
            };
            return assignToSpecificSiAccount(updateData);
          })
          .then(res => {
            this.finished = true;
            swal("設定完成!", "", "success")
            .then(res => {
              this.$router.push({ path: `/retail/gaa/common/${this.businessId}/info?siAccountId=${body.siAccountId}&type=retail` });
            });
          })
          .catch(err => {
            console.log(err);
            if(err.data) {
              swal("錯誤", err.data.error, "error");
            } else {
              swal("錯誤", err.message, "error");
            }
          });
      } else {
        swal("設定已完成!", "", "success")
        .then(res => {
          this.$router.push({ path: `/retail/gaa/common/${this.businessId}/info?siAccountId=${body.siAccountId}&type=retail` });
        });

      }
    }
  }
};
</script>